/**Sums provided array of objects properties **/
const propertySum = (sourceArray, propertyName) =>
  sourceArray?.reduce((acc, curr) => acc + curr[propertyName], 0);
/****/

/**
 * Function that maps callStats data into a new object with as many properties as the tabs you want to show
 * each one with counters, donut and legend data to display.
 *
 * @param {Object} callStats - Object. Contains the call stats from BE.
 * @param {Object} intl - Object. Contains internationalization messages.
 * @param {Object} theme - Object. Contains the DbeTheme properties.
 *
 * @returns {Object} Formatted call stats for StatsBox component.
 */

export default (waveStats, intl, theme) => {
  const colors = theme.custom.generateConsistentUniqueColors(
    waveStats.map(({ filterReason }) => filterReason)
  );
  const mappedWaveData = waveStats.map(
    ({ filterReason, contactCount }, index) => ({
      id: intl.messages[`WAVE_FILTER_REASON_${filterReason}`],
      value: contactCount,
      color: colors[index],
    })
  );

  return {
    alternativeTexts: mappedWaveData.map(({ id }) => id),
    counters: {
      WAVE_TOTAL: propertySum(waveStats, 'contactCount'),
    },
    donut: mappedWaveData,
    legend: {
      data: mappedWaveData
        .filter(({ value }) => value && value !== 0)
        .map(({ id, value }) => `${id}: ${value}`),
      colors,
    },
  };
};
